import { gql } from "@apollo/client";

const SUBIR_DOCUMENTOS_RECLAMO = gql`
    mutation subirDocumentosReclamo($idGestionReclamo: Int!, $input: [ArchivoReclamoInput!]! ){
        subirDocumentosReclamo( idGestionReclamo: $idGestionReclamo, input: $input){
            success
        }
    }
`;

export default SUBIR_DOCUMENTOS_RECLAMO;

export const adaptArchivoInput = (archivo) => {
  return {
    contentType: archivo?.contentType,
    titulo: archivo?.titulo,
    archivo: archivo?.archivo,
    extension: archivo?.extension
  };
};

export const adaptArchivosArrayInput = (archivos) => {
  return structuredClone(archivos)?.map((archivo) => {
    return adaptArchivoInput(archivo);
  });
};